export const SECURITY_REPORT_TITLE = 'securityReport.title';
export const SECURITY_REPORT_MINIMAL_HEADER_TITLE = 'securityReport.minimalHeaderTitle';
export const SECURITY_FOOTER_LINK = 'security.footerLink';

export const SECURITY_REPORT_DISCLOSURE_KEYS = {
  title: 'securityReport.disclosure.title',
  philosophy: {
    title: 'securityReport.disclosure.philosophy.title',
    body: 'securityReport.disclosure.philosophy.body',
  },
  researchers: {
    title: 'securityReport.disclosure.researchers.title',
    body: 'securityReport.disclosure.researchers.body',
  },
  scope: {
    title: 'securityReport.disclosure.scope.title',
    body: 'securityReport.disclosure.scope.body',
  },
  commitment: {
    title: 'securityReport.disclosure.commitment.title',
    items: [
      'securityReport.disclosure.commitment.trust',
      'securityReport.disclosure.commitment.respect',
      'securityReport.disclosure.commitment.transparency',
      'securityReport.disclosure.commitment.commonGood',
    ],
  },
  researcherRequests: {
    title: 'securityReport.disclosure.researcherRequests.title',
    items: [
      'securityReport.disclosure.researcherRequests.trust',
      'securityReport.disclosure.researcherRequests.respect',
      'securityReport.disclosure.researcherRequests.transparency',
      'securityReport.disclosure.researcherRequests.commonGood',
    ],
  },
  reporting: {
    title: 'securityReport.disclosure.reporting.title',
    body: 'securityReport.disclosure.reporting.body',
  },
} as const;
